import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Comprueba la caducidad del JWT al volver a hacer visible la pestaña
 * (`document.visibilitychange` → `visible`), sin esperar a una petición HTTP.
 */
@Injectable({ providedIn: 'root' })
export class SessionExpiryWatcherService {
  private readonly auth = inject(AuthService);
  private started = false;

  /** Registra el listener una sola vez (idempotente). */
  start(): void {
    if (this.started || typeof document === 'undefined') {
      return;
    }
    this.started = true;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.auth.checkSessionExpiredAndLogout();
      }
    });
  }
}
